// extracted by mini-css-extract-plugin
export var banner_wrapper = "webinarBanner-module--banner_wrapper--feb4b";
export var col_6 = "webinarBanner-module--col_6--b7792";
export var quoteImage = "webinarBanner-module--quoteImage--5f84d";
export var span_title = "webinarBanner-module--span_title--d28fa";
export var webinarbanner = "webinarBanner-module--webinarbanner--5e431";